<template>
  <div class="commonDialogBody">
           <!-- <OrganizationalStructure @AllData="getMsgFormSon" style="display:none" /> -->
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;" v-if="ifelse == false">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item :label="formLabelAlign.obj.feeitemName" >
    <el-select  clearable v-model="value" placeholder="请选择收费项目"  size="small" @change="TenementType" >
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item :label="formLabelAlign.obj.displayName">
    <el-input v-model="displayName" size="small" disabled></el-input>
  </el-form-item>
      <el-form-item :label="formLabelAlign.obj.subjectsName" >
     <el-input v-model="formLabelAlign.subjectsName" size="small" disabled></el-input>
    </el-form-item>
     <el-form-item :label="formLabelAlign.obj.taxRate" style="width:95%;">
      <div style="float:right">%</div> <el-input v-model="formLabelAlign.taxRate" size="small" style="width:95%;float:right"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.remark" >
     <el-input v-model="formLabelAlign.remark" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
<div  style="width:70%;margin-left:5%;" v-else>
    <el-select  clearable v-model="value" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrganizationalStructure from "../common/OrganizationalStructure.vue";
export default {
 components: {OrganizationalStructure},
  name: "InvoiceItemDialog",
  //  props:['formLabelAlign'],
  data() {
    return {
    options:[],
     value:"",
     ifelse:false,
     optionsone: [{
          valueone: '1',
          labelone: '是'
        }, {
          valueone: '0',
          labelone: '否'
        }],
        valueone: '',
        disburse:[{
          disburseval: '0',
          disburselab: '预算'
        }, {
          disburseval: '1',
          disburselab: '非预算'
        },
        {
          disburseval: '2',
          disburselab: '其他'
        }],
        disburseval:"",
        dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",
     projectId:"",
     displayName:"",
     taxIds:[],
    };
  },
  methods: {
      handleChange(value){
      },
      TenementType(value){
          for(let val of this.options){
              if(value == val.value){
                // console.log(val)
                  this.displayName = val.displayName
                  this.formLabelAlign.subjectsName = val.subjectsCode
              }
          }
      },
    modification(){
        if(this.title == "修改"){
            let obj = {
                "projectId":this.projectId,
                "id":this.formLabelAlign.id,
                "feeitemCode":this.value,
                "taxRate":this.formLabelAlign.taxRate,
                "subjectsCode":this.formLabelAlign.subjectsName,
                "remarks":this.formLabelAlign.remark,
                "displayName":this.formLabelAlign.feeitemName,
            }
            // console.log(this.formLabelAlign)
        this.$http.post(this.$requestUrl.POST_INVOICE_ADD,obj).then((res) => {
          let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                this.$message({
                  message: '修改成功！',
                  type: 'success'
                });
                let obj = {
                  "reset":false
                }
                this.$emit("reset",obj)
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
        }else if(this.title == "添加"){
             let obj = {
                "projectId":this.projectId,
                "feeitemCode":this.value,
                "taxRate":this.formLabelAlign.taxRate,
                "subjectsCode":this.formLabelAlign.subjectsName,
                "remarks":this.formLabelAlign.remark,
                "displayName":this.displayName
            }
        this.$http.post(this.$requestUrl.POST_INVOICE_ADD,obj).then((res) => {
      let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                let obj = {
                  "reset":false
                }
                this.$emit("reset",obj)
                 this.$message({
                  message: '添加成功！',
                  type: 'success'
                });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
        }else if(this.title == "应用到其他科目"){
          let obj = {
            "projectId":this.value,
            "taxIds":this.taxIds
          }
          let lsit = {
             "reset":false
          }
              this.$http.post(this.$requestUrl.POST_INVOICE_TYPE,obj).then((res) => {
                if(res.data.code == 200){
                   this.$message({
                  message: '应用成功！',
                  type: 'success'
                });
                 this.dialogVisible = false
                  this.$emit("reset",lsit)
                }
              })
        }


    },
    getMsgFormSon(data){
        // console.log(data)
        this.optionsone = data
    },
    // cs(){
    // this.valueone = this.formLabelAlign.expendItem
    // this.disburseval = this.formLabelAlign.subjectAttributes
    // },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
      // console.log(this.formLabelAlign)
    if(this.UserDisplay == 1){
        this.valueone =""
        this.disburseval =""
    }

  if(this.formLabelAlign.obj == undefined){
   let obj = {
            "feeitemName":"收费项目",
            "displayName":"显示名称",
            "subjectsName":"应税科目",
            "taxRate":"税率",
            "remark":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }


  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>